import { Module } from 'vuex';
import infodaycoUpload from '@/modules/infodayco/upload/store/infodayco-upload';
import tutorials from '@/modules/infodayco/tutorials/store/tutorials';
import serviceModels from '@/modules/infodayco/service-model/store/service-models';

const infodayco: Module<any, any> = {
    namespaced: true,
    modules: {
        infodaycoUpload,
        tutorials,
        serviceModels,
    },
};

export default infodayco;
